module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [(_vm.show_notifications) ? _c('router-view', {
    attrs: {
      "name": "header"
    }
  }) : _vm._e()], 1), (_vm.is_authorized) ? _c('global-boxes') : _vm._e(), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "current-view-wrapper"
    }
  }, [_c('transition', {
    attrs: {
      "name": "enter"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "app"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d569e2b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/App.vue
// module id = 1221
// module chunks = 1